import Cookies from "js-cookie";

export function setCompanyIdCookie(companyId) {
  Cookies.set("companyId", companyId, { expires: 30 }); // 30 dias
}

export function getCompanyIdCookie() {
  return Cookies.get("companyId");
}

export function removeCompanyIdCookie() {
  Cookies.remove("companyId");
}
